export default {
  inlineDatePicker: {
    selectDay: 'Выберите день',
    selectMonth: 'Выберите месяц',
    selectYear: 'Выберите год'
  },
  uploader: {
    moveOrLoadPhotoStart: 'Перетащите или',
    moveOrLoadPhotoEnd: ' загрузите фотографию',
    sizeError: 'Файл больше 10 Мб',
    remove: 'Удалить'
  }
}
